import { useCallback } from 'react';

import { ethers } from 'ethers';

import { useEthersSigner } from '@/hooks/useEthersSigner';
import { erc20Abi } from 'smart-contracts/abi/erc20';
import { loanManagerAbi } from 'smart-contracts/abi/loan-manager';
import { nettyworthContractABI } from 'smart-contracts/abi/nettyworth-proxy';
import { nftContractAbi } from 'smart-contracts/abi/nft-contract';
import { whiteListAbi } from 'smart-contracts/abi/white-list';
import { loanManagerAddress, nettyWorthProxyAddress, whiteListAddress } from 'smart-contracts/addresses';

const useErc20Contract = () => {
  const signer = useEthersSigner();

  return useCallback((address: string) => (signer ? new ethers.BaseContract(address, erc20Abi, signer) : null), [signer]);
};

const useNettyContract = () => {
  const signer = useEthersSigner();

  return new ethers.BaseContract(nettyWorthProxyAddress, nettyworthContractABI, signer);
};

const useLoanManagerContract = () => {
  const signer = useEthersSigner();

  return new ethers.BaseContract(loanManagerAddress, loanManagerAbi, signer);
};

const useNFTContract = () => {
  const signer = useEthersSigner();

  return (address: string) => new ethers.BaseContract(address, nftContractAbi, signer);
};

const useWhitelistContract = () => {
  const signer = useEthersSigner();

  return signer ? new ethers.BaseContract(whiteListAddress, whiteListAbi, signer) : null;
};

export { useErc20Contract, useNettyContract, useLoanManagerContract, useNFTContract, useWhitelistContract };
